(() => {
  const init = (root) => {
    if (!root || root.dataset.tandfLoadMoreBound === '1') return;
    root.dataset.tandfLoadMoreBound = '1';

    const btn = root.querySelector('[data-tandf-load-more-btn]');
    const list = root.querySelector('[data-tandf-grid-list]');
    const status = root.querySelector('[data-tandf-status]');
    const progress = root.querySelector('[data-tandf-progress]');
    const progressBar = progress ? progress.closest('[role="progressbar"]') : null;

    if (!btn || !list) return;

    const labelTemplate =
      status?.dataset?.tandfStatusTemplate ||
      'Show [shown] of [total] Products';

    const updateStatus = (shown, total) => {
      if (status) {
        status.textContent = labelTemplate
          .replace('[shown]', shown)
          .replace('[total]', total);
      }
      if (progress && total > 0) {
        const pct = Math.max(0, Math.min(100, (shown / total) * 100));
        progress.style.width = pct + '%';
      }
      if (progressBar) {
        progressBar.setAttribute('aria-valuenow', String(shown));
        progressBar.setAttribute('aria-valuemax', String(total));
      }
      root.dataset.shown = String(shown);
    };

    btn.addEventListener('click', async () => {
      const nextUrl = root.dataset.nextUrl;
      if (!nextUrl || btn.getAttribute('aria-busy') === 'true') return;

      btn.setAttribute('aria-busy', 'true');
      const originalLabel = btn.textContent;
      btn.textContent = 'Loading…';

      try {
        const res = await fetch(nextUrl, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!res.ok) throw new Error('Request failed: ' + res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const nextSection = doc.querySelector('[data-tandf-grid]');
        const nextList = nextSection?.querySelector('[data-tandf-grid-list]');
        if (!nextList) throw new Error('Could not find next grid list');

        const frag = document.createDocumentFragment();
        nextList.querySelectorAll(':scope > li').forEach((li) => {
          frag.appendChild(li.cloneNode(true));
        });
        list.appendChild(frag);

        const newShown = parseInt(nextSection.dataset.shown || '0', 10) || list.childElementCount;
        const total = parseInt(nextSection.dataset.total || root.dataset.total || '0', 10);
        updateStatus(newShown, total);

        const nextNext = nextSection.dataset.nextUrl;
        if (nextNext) {
          root.dataset.nextUrl = nextNext;
        } else {
          delete root.dataset.nextUrl;
          btn.setAttribute('hidden', '');
        }
      } catch (err) {
        console.error('[tandf-load-more]', err);
        btn.textContent = 'Try again';
        setTimeout(() => {
          btn.textContent = originalLabel;
        }, 1800);
      } finally {
        btn.removeAttribute('aria-busy');
        if (!btn.hasAttribute('hidden') && btn.textContent === 'Loading…') {
          btn.textContent = originalLabel;
        }
      }
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-tandf-grid]').forEach((section) => {
      const container = section.querySelector('[data-tandf-load-more]');
      if (container) init(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-tandf-grid]') || e.target;
    if (section?.dataset?.tandfGrid !== undefined || section?.hasAttribute?.('data-tandf-grid')) {
      init(section);
    }
  });
})();
